const SearchList: React.FunctionComponent = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4163 5.62073H24.6576"
        stroke="#35D4AE"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4163 9.24139H21.0369"
        stroke="#35D4AE"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.931 13.4655C24.931 19.8017 19.8017 24.931 13.4655 24.931C7.12931 24.931 2 19.8017 2 13.4655C2 7.12931 7.12931 2 13.4655 2"
        stroke="#4D4D4D"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9999 30L24.3999 24.4"
        stroke="#35D4AE"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchList;
